import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {Chart} from 'chart.js';
// @ts-ignore
import { default as _rollupMoment} from 'moment';
import * as _moment from 'moment';
const moment = _rollupMoment || _moment;


@Component({
  selector: 'app-info-clinical-dialog',
  templateUrl: './info-clinical-dialog.component.html',
  styleUrls: ['./info-clinical-dialog.component.css']
})
export class InfoClinicalDialogComponent implements OnInit {
  array = [];
  title = '';
  public arrayTherapies = [];
  public arrayNotes = [];
  public arrayStart = [];
  public lineChartLabels = [];
  public lineChartType = 'line';
  public lineChartData = [{
    data: this.array,
    dataInizio: this.arrayStart,
    dataTherapies: this.arrayTherapies,
    dataNotes: this.arrayNotes,
    fill: false,
    borderColor: '#005252',
    borderDash: [5, 5],
    pointRadius: 5,
    pointHoverBackgroundColor: '#ff0000',
    label: 'terapia',
  }];
  canvas: any;
  ctx: any;
  myChart: Chart;
  public nota: string;
  public terapia: string;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit(): void {
    for (let k = 0; k < this.data.dataKey.length; k++) {
      this.arrayTherapies[k] = 'nessun piano terapeutico inserito';
      this.arrayNotes[k] = 'nessuna nota inserita';
      this.arrayStart[k] = '-';
    }
    // tslint:disable-next-line:prefer-for-of
    for (let i = this.data.dataKey.length - 1; i >= 0 ; i--) {
      // cerco se la terapia risulta o meno in corso
        if (this.data.dataKey[i].onGoing === '1') {
          this.array.push(this.data.dataKey[i].onGoing);
          this.arrayStart[this.data.dataKey.length - 1 - i] =  this.data.dataKey[i].dateOfStart;
        } else {
          this.array.push('0');
        }
        // metto la data di input, che segnala comunque che a quella data la terapia è in corso oppure no
        this.lineChartLabels.push(this.data.dataKey[i].dateInput);
        // cerco se ci sono terapie corrispondenti alla data e in caso le inserisco nei tooltip
        // tslint:disable-next-line:prefer-for-of
        for (let j = 0; j < this.data.dataTherapies.length; j++) {
          // prendo solo la data e non l'ora
          const dataTherapy = moment(this.data.dataTherapies[j].date, 'DD/MM/YYYY').toDate();
          const dataValue = moment(this.data.dataKey[i].dateInput, 'DD/MM/YYYY').toDate();
          if (dataTherapy.toString() === dataValue.toString()) {
            this.arrayTherapies[this.data.dataKey.length - i - 1] = this.data.dataTherapies[j].therapy;
            break;
          }
        }
        // tslint:disable-next-line:prefer-for-of
        for (let j = 0; j < this.data.dataNotes.length; j++) {
          const dataNote = moment(this.data.dataNotes[j].split('-')[0], 'DD/MM/YYYY').toDate();
          const dataValue = moment(this.data.dataKey[i].dateInput, 'DD/MM/YYYY').toDate();
          if (dataNote.toString() === dataValue.toString()) {
            this.arrayNotes[this.data.dataKey.length - i - 1] = this.data.dataNotes[j].split('-')[1];
            break;
          }
        }
    }
    this.title = this.data.dataTitle;
    this.canvas = document.getElementById('myChart') as HTMLCanvasElement;
    this.ctx = this.canvas.getContext('2d');
    // @ts-ignore
    this.myChart = new Chart(this.ctx, {
      type: this.lineChartType,
      data: {
        labels: this.lineChartLabels,
        datasets: this.lineChartData,
        // @ts-ignore
        descriptions: this.arrayTherapies,
      },
      options: {
        maintainAspectRatio: true,
        scales: {
          xAxes: [{
            display: true,
            ticks: {
              fontSize: 12,
              fontStyle: 'bold',
              fontFamily: 'Helvetica',
              fontColor: '#006192'
            }
          }],
          yAxes: [{
            display: true,
            ticks: {
              min: 0,
              max: 1,
              stepSize: 1,
              fontSize: 12,
              fontStyle: 'bold',
              fontFamily: 'Helvetica',
              fontColor: '#006192'
            }
          }],
        },
        legend: {
          display: true,
          position: 'top',
          labels: {
            usePointStyle: true,
            fontColor: '#006192',
            fontSize: 18,
            fontFamily: 'Helvetica',
          }
        },
        tooltips: {
          backgroundColor: '#1c1c1c',
          bodyFontSize: 18,
          titleFontSize: 18,
          cornerRadius: 5,
          caretPadding: 10,
          position: 'nearest',
          callbacks: {
            afterTitle(tooltipItem, data): string | string[] {
              // @ts-ignore
              if (data.datasets[0].data[tooltipItem[0].index] === '1') {
                // @ts-ignore
                const tooltipText = 'Terapia: in corso' + ' DATA INIZIO: ' + data.datasets[0].dataInizio[tooltipItem[0].index];
                return tooltipText;
              } else {
                const tooltipText = 'Terapia: NON in corso';
                return tooltipText;
              }
            },
            label(tooltipItem, data) {
              // @ts-ignore
              if (data.datasets[0].dataTherapies[tooltipItem.index] !== 'nessun piano terapeutico inserito') {
                // @ts-ignore
                let tooltipText = 'Piano terapeutico: ' + data.datasets[0].dataTherapies[tooltipItem.index];
                if (tooltipText.length > 40) {
                  tooltipText = tooltipText.substr(0, 40) + ' [...]';
                  return tooltipText;
                } else {
                  return tooltipText;
                }
              } else {
                // @ts-ignore
                const tooltipText = 'Piano terapeutico: ' + data.datasets[0].dataTherapies[tooltipItem.index];
                return tooltipText;
              }
            },
            afterLabel(tooltipItem: Chart.ChartTooltipItem, data: Chart.ChartData): string | string[] {
              // @ts-ignore
              if (data.datasets[0].dataNotes[tooltipItem.index] !== 'nessuna nota inserita') {
                // @ts-ignore
                let tooltipText = 'Note: ' + data.datasets[0].dataNotes[tooltipItem.index];
                if (tooltipText.length > 40) {
                  tooltipText = tooltipText.substr(0, 40) + ' [...]';
                  return tooltipText;
                } else {
                  return tooltipText;
                }
              } else {
                // @ts-ignore
                const tooltipText = 'Note: ' + data.datasets[0].dataNotes[tooltipItem.index];
                return tooltipText;
              }
            }
          },
          bodyAlign: 'center',
          caretSize: 0,
          footerAlign: 'left',
          footerMarginTop: 6,
          footerSpacing: 2,
          xPadding: 50,
          },
        title: {
          display: true,
          text: this.title,
          fontColor: '#006192',
          fontSize: 20,
          fontFamily: 'Helvetica',
        },
        hover: {
          mode: 'nearest',
          intersect: true
        },
        onHover: (event: MouseEvent) => {
            if (this.myChart.getElementAtEvent(event).length > 0) {
              // @ts-ignore
              // console.log(this.myChart.getElementAtEvent(event)[0]._index);
              // @ts-ignore
              this.terapia = this.arrayTherapies[this.myChart.getElementAtEvent(event)[0]._index];
              // @ts-ignore
              this.nota = this.arrayNotes[this.myChart.getElementAtEvent(event)[0]._index];
            }
        },
      }
    });
  }


}
